export const AMOUNT_TO_FETCH = 20;

export const DEFAULT_OFFSET = 0;
